import React from 'react'
import Header from './Header'
import Footer from './Footer'
export default function WhyAnnpurna() {
 return (
    <>
    <Header />
    <section className="page-title centred" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/resource/bg-img.jpg)`}}>
            <div className="pattern-layer"></div>
            <div className="auto-container">
                <div className="content-box">
                    <h1>Why Annapurna</h1>
                    <ul className="bread-crumb clearfix">
                        <li><i className="flaticon-home-1"></i><a href="index.html">Home</a></li>
                        <li>Why Annapurna</li>
                    </ul>
                </div>
            </div>
        </section>
      <section className="about-section" style={{padding:"3px 0px"}}>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-column">
            <div className="text-inner">
              <h2 className="three text-left">Health Benefits – Backed by Ayurveda & Nutritional Science</h2>
              
            </div>
           </div>
         </div>
         <div className="row">
          <div className="col-md-12">
           <ul>
            <li><strong>Boosts Immunity –</strong> Rich in antioxidants and essential trace minerals (selenium, zinc)</li>
            <li><strong>Natural Detoxifier –</strong> Supports liver cleansing and respiratory health</li>
            <li><strong>Aids Digestion –</strong> Stimulates digestive enzymes and bile secretion</li>
            <li><strong>Iron-Rich –</strong> Enhances hemoglobin; ideal for women and adolescents</li>
            <li><strong>Sustained Energy Source –</strong>  Low glycemic release reduces energy crashes</li>
            <li><strong>Anti-Allergic Properties –</strong> Helps relieve seasonal allergies</li>
            <li><strong>Supports Diabetes Management –</strong>  When consumed in moderation, jaggery may aid blood sugar regulation</li>
            
           </ul>
          </div>
          
         </div>
      </div>
    </section>
     <section className="about-section" style={{padding:"3px 0px"}}>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-column">
            <div className="text-inner">
              <h2 className="three text-left">The Science Behind Annapurna – Our Unique Advantage</h2>
              
            </div>
           </div>
         </div>
         <div className="row">
          <div className="col-md-12">
            <p>Our production model integrates traditional processing with scientific rigor and public health best practices:</p>
           <ul>
            <li><strong>Low-Temperature Evaporation Units –</strong>  Retains natural micronutrients</li>
            <li><strong>Zero-Chemical Clarification –</strong>  No sulphur, lime, or phosphoric acid</li>
            <li><strong>Solar-Assisted Drying –</strong>  Reduces microbial load and carbon footprint</li>
            <li><strong>Batch-Level Traceability –</strong>  Every lot is linked to a certified organic farm cluster</li>
            <li><strong>HACCP-Aligned SOPs –</strong>   Food safety protocols tailored for rural clean-room settings</li>
            
            
           </ul>
          </div>
          
         </div>
      </div>
    </section>
     <section className="about-section" style={{padding:"3px 0px"}}>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-column">
            <div className="text-inner">
              <h2 className="three text-left">The Science Behind Annapurna – Our Unique Advantage</h2>
              
            </div>
           </div>
         </div>
         <div className="row">
          <div className="col-md-12">
            <p>Our production model integrates traditional processing with scientific rigor and public health best practices:</p>
           <ul>
            <li><strong>Low-Temperature Evaporation Units –</strong>  Retains natural micronutrients</li>
            <li><strong>Zero-Chemical Clarification –</strong>  No sulphur, lime, or phosphoric acid</li>
            <li><strong>Solar-Assisted Drying –</strong>  Reduces microbial load and carbon footprint</li>
            <li><strong>Batch-Level Traceability –</strong>  Every lot is linked to a certified organic farm cluster</li>
            <li><strong>HACCP-Aligned SOPs –</strong>   Food safety protocols tailored for rural clean-room settings</li>
            
            
           </ul>
          </div>
          
         </div>
      </div>
    </section>
     <section className="about-section" style={{padding:"3px 0px"}}>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-column">
            <div className="text-inner">
              <h2 className="three text-left">From Farm to Pack – Transparent, Traceable, Trusted</h2>
              
            </div>
           </div>
         </div>
         <div className="row">
          <div className="col-md-12">
            <p>All raw materials are sourced directly from contracted organic farmers trained under Jan Sewa Ashram’s agri-extension program. Our regenerative and climate-smart farming practices include:</p>
           <ul>
            <li><strong>Nanak Kheti</strong>   (Deep ploughing for soil health and water retention)</li>
            <li><strong>Crop Rotation & Green Manuring</strong>  for soil fertility</li>
            <li><strong> Biological Pest Control</strong>  using Trichoderma, neem-based formulations</li>
            <li><strong>Rainwater Harvesting & Micro-Irrigation –</strong>   systems</li>
            <li><strong>Digital Farm Logs – </strong> Auditable records for certification and compliance</li>
            
            
           </ul>
          </div>
          
         </div>
      </div>
    </section>
    <Footer />
    </>
  )
}
